import flatten from '@/util/flatten'

/**
 * Field mixins for RfForm
 */
export default {
  methods: {
    /**
     * Reset value and clear validation UI for all fields in the form
     * @param  {Array|String}  fieldNames
     */
    resetFields (...fieldNames) {
      fieldNames = flatten(fieldNames)
      fieldNames.forEach(function (fieldName) {
        if (this.field(fieldName)) {
          this.field(fieldName).reset()
        }
      }.bind(this))
    },

    /**
     * Field helper: quickly get the value of a field from the field instance
     * itself (not form.fieldData)
     * @param   {string}  name
     * @return  {string|array|undefined}
     */
    value (name) {
      return this.field(name) ? this.field(name).value : undefined
    },

    /**
     * Get a field VM
     * @param   {string}  name
     * @return  {Vue|false}
     */
    field (name) {
      let matches = this.getFields().filter(vm => {
        return vm.name === name
      })

      return matches.length ? matches[0] : false
    },

    /**
     * Perform actions when a child field is added to the form
     * @param   {Vue}    fieldVm
     */
    _onFieldAdded (fieldVm) {
      // Warn if any duplicate field names detected
      if (typeof this.fieldData[fieldVm.name] !== 'undefined') {
        this.$error('Duplicate field name detected:', fieldVm.name)
      }

      // Warn if any duplicate field IDs detected
      Object.keys(this.fieldData).forEach(field => {
        if (this.fieldData[field].id === fieldVm.fieldId) {
          this.$error('Duplicate field ID detected:', fieldVm.fieldId)
        }
      })

      // Properly 'add' our field name to the root field data object. This sets
      // up observation properly, see https://vuejs.org/2016/02/06/common-gotchas/
      this.$set(this.fieldData, fieldVm.name, {
        // Generate random fieldId if one doesn't exist
        // https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript/38622545#38622545
        id: fieldVm.fieldId || Math.random().toString(36).substr(2, 5),
        name: fieldVm.name,
        value: fieldVm.value
      })
    },
    _onFieldDestroyed (name) {
      this.$delete(this.fieldData, name)
      this.errors.remove(name)
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/form/fields.js